<template>
  <v-col cols="12" sm="12">
    <v-col cols="6" sm="6">
      <v-toolbar-title>Cuadrillas</v-toolbar-title>
      <template v-if="$store.getters.usuario.idRol == 5">
        <v-autocomplete
          v-model="contratistaSeleccionado"
          :items="listaContratistas"
          item-value="idContratista"
          item-text="descripcionContratista"
          required
          attach
          prepend-icon="mdi-truck"
          label="Contratista"
          no-data-text="No se encontraron contratistas"
          hint="Seleccione la contratista para ver sus materiales"
          persistent-hint
          @change="cambioContratista"
        ></v-autocomplete>
      </template>
      <br />
      <v-text-field
        v-model="buscar"
        :append-icon="'mdi-select-search'"
        label="Buscar Cuadrilla por Id / Contratista / Descripciòn en la tabla"
        dense
      ></v-text-field>
    </v-col>
    <v-data-table
      :headers="headers"
      :items="cuadrillas"
      item-key="idCuadrilla"
      sort-by="idCuadrilla"
      :search="buscar"
      :header-props="headerProps"
      :footer-props="footerProps"
      no-data-text="No se encontraron registros"
      no-results-text="No se encontraron registros en la búsqueda"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <!-- <v-divider class="mx-4" inset vertical></v-divider> -->
          <v-spacer></v-spacer>
          <v-tooltip left color="indigo">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                elevation="10"
                small
                fab
                color="indigo"
                dark
                class="mx-2"
                @click="AbrirModal(0)"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon dark> mdi-plus </v-icon>
              </v-btn>
            </template>
            <span>Armar Cuadrilla</span>
          </v-tooltip>

          <insertCuadrilla
            ref="abrirModalInsert_Update"
            @recargarListado="recargarListado()"
          ></insertCuadrilla>

          <v-dialog v-model="dialogDelete" max-width="800px">
            <v-card>
              <v-card-title class="text-h5"
                >¿Está seguro que desea eliminar esta cuadrilla?</v-card-title
              >
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDelete"
                  >Cancel</v-btn
                >
                <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                  >OK</v-btn
                >
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <!-- <v-tooltip bottom mg="1">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              color="green"
              fab
              x-small
              dark
              class="ml-2"
              @click="editarEjecutor(item)"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </template>
          <span>Editar Ejecutor</span>
        </v-tooltip>

        <v-tooltip bottom mg="1">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              color="red"
              fab
              x-small
              dark
              class="ml-2"
              @click="eliminarEjecutor(item)"
            >
              <v-icon>mdi-delete-forever</v-icon>
            </v-btn>
          </template>
          <span>Eliminar Ejecutor</span>
        </v-tooltip> -->
        <v-tooltip left color="green">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              elevation="10"
              small
              fab
              color="green"
              dark
              class="mx-2"
              @click="AbrirModalModificacion(item)"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon dark> mdi-pencil </v-icon>
            </v-btn>
          </template>
          <span>Modificar Cuadrilla</span>
        </v-tooltip>
        <v-tooltip left color="red">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              elevation="10"
              small
              fab
              color="red"
              dark
              class="mx-2"
              @click="cerrarCuadrilla(item)"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon dark> mdi-close-circle-outline </v-icon>
            </v-btn>
          </template>
          <span>Cerrar Cuadrilla</span>
        </v-tooltip>
        <v-tooltip left color="orange">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              elevation="10"
              small
              fab
              color="orange"
              dark
              class="mx-2"
              @click="abrirAsignarTareas(item)"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon dark> mdi-format-list-bulleted </v-icon>
            </v-btn>
          </template>
          <span>Asignar Tarea</span>
        </v-tooltip>
      </template>
    </v-data-table>

    <dialog-mensaje ref="dialogMensaje" @resultado="confirmarOperacion" />
  </v-col>
</template>
<script>
import dialogMensaje from "@/components/modalMensaje.vue";
import insertCuadrilla from "@/modulos/Cuadrilla/componentes/modalCuadrillas.vue";
import axios from "axios";
export default {
  components: {
    insertCuadrilla,
    dialogMensaje,
  },
  data: () => ({
    contratistaSeleccionado: "",
    listaContratistas: [],
    tipoConsulta: 0,
    idCuadrillaEliminar: "",
    dialogDelete: false,
    headers: [
      {
        text: "Id",
        align: "start",
        sortable: true,
        value: "idCuadrilla",
        class: "black white--text",
      },
      { text: "Descripción", value: "cuadrilla", class: "black white--text" },
      {
        text: "Fecha de Creacion",
        value: "fechaCreacion",
        class: "black white--text",
      },
      {
        text: "Acciones",
        value: "actions",
        sortable: false,
        class: "black white--text",
      },
    ],
    headerProps: {
      sortByText: "Ordenar por",
    },
    other: [1, 20, 344, 44444],
    footerProps: {
      itemsPerPageText: "Registros por página",
      pageText: "{0}-{1} de {2}",
      itemsPerPageOptions: [5, 10, 20, 50, 100, { text: "Todos", value: -1 }],
    },
    buscar: "",
    cuadrillas: [],
    editedIndex: -1,
    editedItem: {
      idCuadrilla: "",
      descripcion: 0,
    },
    defaultItem: {
      idCuadrilla: "",
      descripcion: 0,
    },
  }),

  watch: {
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  async mounted() {
    //this.getListarCuadrilla();
    // Mostrar los datos en la consola
    console.log("Ingreso en las cuadrillas");
    console.log(this.$store.getters.usuario);
    if (this.$store.getters.usuario.idRol == 5) {
      await this.getListarContratistas();
      this.reiniciarIdContratista();
    } else {
      await this.getListarCuadrillaByContratista();
    }
    //this.getRecuperarServicios();
  },
  methods: {
    reiniciarIdContratista() {
      this.$store.getters.usuario.idContratista = 0;
    },
    async getListarContratistas() {
      console.log("Ingreso en listar contratistas");
      // this.url = "https://localhost:5001Contractor/getlistado";
      this.url =
        this.$store.getters.urlBase +
        "Contractor/recuperarContratistasAsociados?idUsuario=" +
        this.$store.getters.usuario.user_id;
      // const config = {
      //   headers: {
      //     Authorization: `Bearer ${this.$store.getters.usuario.token}`,
      //   },
      // };

      //var listacontratistas = [];

      await axios
        .get(this.url)
        .then((response) => {
          console.log(response.data);
          this.listaContratistas = response.data;
        })
        .catch((error) => {
          console.log(error.response);
          if (error.response == undefined) {
            this.mensajeSnack = "Error de Conexion";
          } else {
            if (error.response.status === 401) {
              this.mensajeSnack =
                "No posee autorizacion para ver esta informacion";
            } else {
              if (error.response.data != "") {
                this.mensajeSnack = error.response.data;
              }
            }
          }
          this.loadingButton = false;
          this.colorSnack = "red";
          this.Showsnackbar = true;
        });
      this.loadingButton = false;
    },
    async cambioContratista() {
      console.log("El contratista es: ");
      console.log(this.contratistaSeleccionado);
      this.$store.getters.usuario.idContratista = this.contratistaSeleccionado;
      await this.getListarCuadrillaByContratista();
    },
    async confirmarOperacion(resultadoFinal) {
      console.log("Esto hay en el resultado final");
      console.log(resultadoFinal);
      console.log("El tipo de consulta es: ");
      console.log(this.tipoConsulta);

      //var obj;

      if (resultadoFinal == true) {
        if (this.tipoConsulta == 3) {
          // this.url =
          //   this.$store.state.urlBase + "Cajon/cerrarCajon?idCajon=";
          // this.idCajonEliminar;
          this.url = this.$store.state.urlBase + "Cuadrilla/cerrarCuadrilla";

          // obj = {
          //   idCajon: this.idCajon,
          // };
        }

        var obj = {
          idCuadrilla: this.idCuadrillaEliminar,
          idUsuario: this.$store.getters.usuario.user_id,
        };

        // const config = {
        //   headers: {
        //     Authorization: `Bearer ${sessionStorage.getItem("Token")}`,
        //   },
        // };

        var respuesta = await axios
          .post(this.url, obj)
          .then((response) => {
            return response;
          })
          .catch(function () {
            return null;
          });

        console.log("Esto hay en el respuesta");
        console.log(respuesta);

        if (respuesta.status == 200) {
          this.mensajeDelDialog = respuesta.data;

          var mensajeDialog = "";
          if (this.mensajeDelDialog == true) {
            mensajeDialog = "Operacion Exitosa";
          } else {
            mensajeDialog = "Operacion Rechazada";
          }

          this.$refs.dialogMensaje.abrirMensajeDialog(
            mensajeDialog,
            1,
            this.mensajeDelDialog == true ? "green" : "red",
            "Informacion"
          );
        } else {
          console.log("Ingreso en el else de la respuesta");
          this.$refs.dialogMensaje.abrirMensajeDialog(respuesta.Error, 1);
          this.mensajeDelDialog = respuesta.Error;
          this.mensajeDelDialog = respuesta.Error.split("-");
          this.colorDialog = "red";
          this.dialog = true;
        }

        this.recargarListado();
      }
    },

    async recargarListado() {
      await this.getListarCuadrillaByContratista();
    },

    async confirmarCierreCuadrilla(resultadoFinal) {
      //console.log("Ingreso en confirmar cierre ");
      if (resultadoFinal == true) {
        //console.log("Ingreso en el true del confirmar cierre");
        this.url = this.$store.getters.urlBase + "Cuadrilla/cerrarCuadrilla";

        // const config = {
        //   headers: {
        //     Authorization: `Bearer ${sessionStorage.getItem("Token")}`,
        //   },
        // };

        var obj = {
          idCuadrilla: this.idCuadrillaEliminar,
          idUsuario: this.$store.getters.usuario.user_id,
        };

        console.log("La direccion es: ");
        console.log(this.url);

        var respuesta = await axios
          .post(this.url, obj)
          .then((response) => {
            return response;
          })
          .catch(function () {
            return null;
          });

        console.log("Esto hay en el respuesta");
        console.log(respuesta);

        if (respuesta.status == 200) {
          this.mensajeDelDialog = respuesta.data;

          var mensajeDialog = "";
          if (this.mensajeDelDialog == true) {
            mensajeDialog = "Operacion Exitosa";
          } else {
            mensajeDialog = "Operacion Rechazada";
          }

          this.$refs.dialogMensaje.abrirMensajeDialog(
            mensajeDialog,
            1,
            this.mensajeDelDialog == true ? "green" : "red",
            "Informacion"
          );
        } else {
          console.log("Ingreso en el else de la respuesta");
          this.$refs.dialogMensaje.abrirMensajeDialog(respuesta.Error, 1);
          this.mensajeDelDialog = respuesta.Error;
          this.mensajeDelDialog = respuesta.Error.split("-");
          this.colorDialog = "red";
          this.dialog = true;
        }

        if (this.bandera == 1) {
          console.log("Ingresoe en la bandera 1 para ocultar el dialog");
          this.dialogForm = false;
        }

        this.$router.push("/Cuadrillas");
      }
    },

    abrirAsignarTareas(datos) {
      this.$router.push({
        name: "Asignar Tarea a Cuadrilla",
        params: { datos },
      });
    },
    AbrirModal(tipo) {
      console.log("El contratista es: ");
      console.log(this.$store.getters.usuario.idContratista);
      this.$refs.abrirModalInsert_Update.openModal(tipo);
    },
    AbrirModalModificacion(item) {
      this.$refs.abrirModalInsert_Update.openModalModificacion(item);
    },
    deleteItem(item) {
      this.editedIndex = this.cuadrillas.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.cuadrillas.splice(this.editedIndex, 1);
      this.closeDelete();
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    cerrarCuadrilla(datosCuadrilla) {
      console.log("Los datos para eliminar");
      console.log(datosCuadrilla);
      this.idCajonEliminar = datosCuadrilla.idCuadrilla;
      this.tipoConsulta = 3;
      this.idCuadrillaEliminar = datosCuadrilla.idCuadrilla;
      if (datosCuadrilla.cantidadTareas > 0) {
        this.$refs.dialogMensaje.abrirMensajeDialog(
          "No puede cerrar un cuadrilla que tenga tareas despachadas",
          1,
          "red",
          "Aviso"
        );
        return;
      }

      this.$refs.dialogMensaje.abrirMensajeDialog(
        "Desea cerrar la cuadrilla " + datosCuadrilla.idCuadrilla + " ?",
        2,
        "red",
        "Aviso"
      );
    },

    async getListarCuadrilla() {
      this.url = this.$store.getters.urlBase + "Gang";
      const options = {
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
        url: this.url,
      };
      var respuesta = await axios(this.url, options);
      if (respuesta.status === 200) {
        console.log("la lista de cuadrilla es:");
        console.log(respuesta.data);
        this.cuadrillas = respuesta.data;
        // this.getListarDiasMantenimiento();
      } else {
        // this.colorSnack = "red";
        // this.mensajeSnack = respuesta.data;
        // this.Showsnackbar = true;
        console.log("Error");
      }
    },

    async getListarCuadrillaByContratista() {
      console.log("getListarCuadrillaByContratista");
      console.log(this.$store.getters.usuario.idContratista);
      console.log(this.$store.getters.usuario.user_id);

      // Construir la URL con parámetros de consulta
      const idUsuario = this.$store.getters.usuario.user_id;
      const idEmpresa =
        this.$store.getters.usuario.idContratista == null
          ? 2
          : this.$store.getters.usuario.idContratista;
      const idDistrito = this.$store.getters.usuario.idDistrito;

      this.url = `${this.$store.getters.urlBase}Cuadrilla?idUsuario=${idUsuario}&idEmpresa=${idEmpresa}&idDistrito=${idDistrito}`;

      console.log(idUsuario);
      console.log(idEmpresa);

      try {
        const respuesta = await axios.get(this.url, {
          headers: { "Content-Type": "application/json" },
        });

        if (respuesta.status === 200) {
          console.log("la lista de cuadrilla es:");
          console.log(respuesta.data);
          this.cuadrillas = respuesta.data;
        }
      } catch (error) {
        console.error("Error en la solicitud:", error);
      }
    },

    // async getListarCuadrillaByContratista() {
    //   console.log("EgetListarCuadrillaByContratista");
    //   console.log(this.$store.getters.usuario.idContratista);

    //   if (this.$store.getters.usuario.idContratista == null) {
    //     this.$store.getters.usuario.idContratista == 2;
    //   }

    //   console.log(this.$store.getters.usuario.idContratista);

    //   this.url =
    //     this.$store.getters.urlBase +
    //     "Cuadrilla?idContratista=" +
    //     this.$store.getters.usuario.idContratista;
    //   const options = {
    //     method: "GET",
    //     headers: {
    //       "content-type": "application/json",
    //     },
    //     // params: {
    //     //   idcontratista:
    //     //     this.$store.getters.usuario.idRol != 3
    //     //       ? this.contratistaSeleccion
    //     //       : this.$store.getters.idContratista,
    //     // },
    //     url: this.url,
    //   };
    //   var respuesta = await axios(this.url, options);
    //   if (respuesta.status === 200) {
    //     console.log("la lista de cuadrilla es:");
    //     console.log(respuesta.data);
    //     this.cuadrillas = respuesta.data;
    //     // this.getListarDiasMantenimiento();
    //   } else {
    //     // this.colorSnack = "red";
    //     // this.mensajeSnack = respuesta.data;
    //     // this.Showsnackbar = true;
    //     console.log("Error");
    //   }
    // },

    async getRecuperarServicios() {
      this.url = this.$store.getters.urlBase + "Gang/servicios";
      const options = {
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
        url: this.url,
      };
      var respuesta = await axios(this.url, options);
      if (respuesta.status === 200) {
        console.log("Los servicios son");
        console.log(respuesta.data);
        //this.cuadrillas = respuesta.data;
        // this.getListarDiasMantenimiento();
      } else {
        // this.colorSnack = "red";
        // this.mensajeSnack = respuesta.data;
        // this.Showsnackbar = true;
        console.log("Error");
      }
    },
  },
};
</script>
